var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.25C4.48122 9.25 3.25 10.4812 3.25 12V20C3.25 21.5188 4.48122 22.75 6 22.75H18C19.5188 22.75 20.75 21.5188 20.75 20V12C20.75 10.4812 19.5188 9.25 18 9.25H17.7478V7C17.7478 5.32956 17.1877 3.87925 16.1531 2.84467C15.1185 1.81009 13.6682 1.25 11.9978 1.25C10.3274 1.25 8.87706 1.81009 7.84247 2.84467C6.80789 3.87925 6.2478 5.32956 6.2478 7V9.25H6ZM6 10.75C5.30964 10.75 4.75 11.3096 4.75 12V20C4.75 20.6904 5.30964 21.25 6 21.25H18C18.6904 21.25 19.25 20.6904 19.25 20V12C19.25 11.3096 18.6904 10.75 18 10.75H6ZM8.90313 3.90533C8.18772 4.62075 7.7478 5.67044 7.7478 7V9.25H16.2478V7C16.2478 5.67044 15.8079 4.62075 15.0925 3.90533C14.3771 3.18991 13.3274 2.75 11.9978 2.75C10.6682 2.75 9.61855 3.18991 8.90313 3.90533Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.aaec4dd1ea3c0d8c4989e0721676ad4b.svg";
export { ForwardRef as ReactComponent };